import React, {useEffect} from "react";

import './Field.scss';

const Field = props => {
	const {title, children, highlight} = props;

	return (
		<div className="field-container">
			<div className="field-title">{title}</div>
			<span style={{color: highlight ? '#40A0C1' : '#142A31'}}>{children}</span>
		</div>
	)
};

export default Field;
